// extracted by mini-css-extract-plugin
module.exports = {"root":"CenteredColon_root__Xj1Je","dot":"CenteredColon_dot__Om01m"};